import React from "react";

export interface MenuItemData {
  id: string;
  label: string;
  onClick: (item: MenuItemData) => void;
  color?: string;
  /** When true, the option is visible but not selectable. */
  disabled?: boolean;
  /** When set, a checkbox is shown before the label. */
  checked?: boolean;
  /** Defaults to true. Set false for checkbox options so the menu stays open. */
  closeOnClick?: boolean;
}

interface MenuItemProps {
  label: string;
  onClick: () => void;
  color?: string;
  className?: string;
  disabled?: boolean;
  checked?: boolean;
}

export function MenuItem({ label, onClick, className, color, disabled, checked }: MenuItemProps) {
  const isCheckboxItem = checked !== undefined;

  return (
    <div
      role={isCheckboxItem ? "menuitemcheckbox" : "menuitem"}
      aria-checked={isCheckboxItem ? checked : undefined}
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : 0}
      className={["menu-item", disabled && "menu-item--disabled", className]
        .filter(Boolean)
        .join(" ")}
      onClick={(event) => {
        if (disabled) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        onClick();
      }}
      onKeyDown={(event) => {
        if (disabled) return;
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onClick();
        }
      }}
      style={{ color: disabled ? undefined : color }}
    >
      {isCheckboxItem && (
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          readOnly
          tabIndex={-1}
          aria-hidden
        />
      )}
      {label}
    </div>
  );
}

